import { RecurringInvoiceSpawnMode } from '../../../types/recurringInvoiceSpawnMode'

export const recurringSpawnModeKeyToTranslationKey: Record<RecurringInvoiceSpawnMode, string> = {
  approve: 'legacy_recurring_invoices_list.recurring_spawn_mode.invoice_only',
  draft: 'legacy_recurring_invoices_list.recurring_spawn_mode.draft_invoice',
  email: 'legacy_recurring_invoices_list.recurring_spawn_mode.invoice_and_email',
}
